import { AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, ViewChild } from '@angular/core';
import { StatesService } from '@app/core/services/states.service';
import { Transaction } from '@app/transactions/transaction';
import { Subscription, filter, Subject, BehaviorSubject, delay } from 'rxjs';
import { TransactionInfoService } from '../../../transaction-info.service';
import { DocumentCollection } from 'ngx-jsonapi';
import { State } from '@app/core/resources/state';
import { StatePublicHelper } from '@app/core/helpers/state-public.helper';
import { SlideComponent } from '@app/core/components/slide/slide.component';

@Component({
    selector: 'app-stepper-transaction-states',
    templateUrl: './stepper-transaction-states.component.html',
    styleUrls: ['./stepper-transaction-states.component.scss']
})
export class StepperTransactionStatesComponent implements OnDestroy, OnChanges, AfterViewInit {
    @Input() public beforepath: string = '';
    @Input() public beforepathCreate: string = '';
    @Input() public transaction!: Transaction;
    @ViewChild('slide') public slide!: SlideComponent;
    private testSubject: Subject<any> = new BehaviorSubject<any>(false);
    public statePublicHelper: StatePublicHelper = new StatePublicHelper();
    public statesTransaction: Array<number> = [0];
    public currentState!: any;
    public permanentState: any = [
        {
            state: 0,
            title: 'Creaste tu pedido',
            progressBar: 100,
            opacity: false
        },
        {
            state: 11,
            title: 'Esperando tu pago',
            progressBar: 0,
            opacity: true
        },
        {
            state: 12,
            title: 'Enviando tu saldo',
            progressBar: 0,
            opacity: true
        },
        {
            state: 22,
            title: 'Pedido finalizado',
            progressBar: 0,
            opacity: true
        }
    ];
    private subscription: Subscription = new Subscription();
    private subscriptionState: Subscription = new Subscription();

    public constructor(
        private changeDetectorRef: ChangeDetectorRef,
        public statesService: StatesService,
        public transactionInfoService: TransactionInfoService
    ) {}

    public ngOnChanges(): void {
        if (this.beforepath !== '') {
            this.getTransaction();
        }
        this.getStatesInTransactionPublic();
    }

    public ngAfterViewInit(): void {
        this.testSubject
            .asObservable()
            .pipe(delay(0))
            .subscribe(() => {
                if (this.slide.paymentMethod.nativeElement.offsetWidth > this.slide.paymentMethodContainer.nativeElement.offsetWidth) {
                    this.slide.paymentMethodContainer.nativeElement.classList.add('scrollable');
                }
            });
    }

    private setStateInArray(statesTransaction: Array<number>, statesArray: any): void {
        statesTransaction.forEach((state: any) => {
            let currentState: any = this.permanentState.find((element: any) => element.state === state);
            if (currentState) {
                this.currentState = currentState;
            }
        });

        let lastStateTransaction: any = statesTransaction[statesTransaction.length - 1];
        let index: number = this.permanentState.indexOf(this.currentState);
        if (lastStateTransaction && this.currentState.state !== lastStateTransaction) {
            let indexSplice: number = this.currentState.state === 22 ? index : index + 1;
            statesArray.splice(indexSplice, 0, {
                state: this.transaction.attributes.state,
                title: this.statePublicHelper.getStateDetail(this.transaction.attributes.state).title,
                progressBar: this.transaction.attributes.state === 22 || this.transaction.attributes.state === 1 ? 0 : 50,
                opacity: false
            });
            let indexForPermanent: number = this.currentState.state === 22 ? index - 1 : index;
            this.permanentState[indexForPermanent].progressBar = 100;
            this.permanentState[indexForPermanent].opacity = false;
        }

        if (this.transaction.attributes.state === 11) {
            this.permanentState[index].progressBar = this.setProgressBar();
        }
        this.permanentState[index].opacity = false;

        return;
    }

    private setProgressBar(): number {
        return this.transaction.attributes.marked_as_sent ? 50 : 25;
    }

    private updateStateInArray(): void {
        let indexState: number = 0;
        let auxState: number = 1;

        this.permanentState.forEach((element: any, index: any) => {
            if (element.state === this.transaction.attributes.state) {
                indexState = index;
            }
        });

        for (let i: number = indexState - auxState; i >= 0; i--) {
            this.permanentState[i].state = 0;
            this.permanentState[i].progressBar = 100;
            this.permanentState[i].opacity = false;
        }
    }

    private getTransaction(): void {
        if (this.transaction) {
            this.getStates();

            return;
        }
        this.subscription = this.transactionInfoService.transaction$.subscribe((transaction): void => {
            this.transaction = transaction;
            this.getStates();
            this.changeDetectorRef.markForCheck();
        });
    }

    private getStatesInTransactionPublic(): void {
        this.transaction.relationships.states.data.forEach((element: any) => {
            this.statesTransaction.push(element.attributes.state);
        });
        this.setStateInArray(this.statesTransaction, this.permanentState);
        this.updateStateInArray();
        this.testSubject.next(true);
    }

    private getStates(): void {
        this.subscriptionState = this.statesService
            // eslint-disable-next-line id-blacklist
            .all({ include: ['state_actions'], beforepath: this.beforepath, page: { size: 250, number: 1 } })
            .pipe(filter((states: DocumentCollection<State>) => states.source !== 'new'))
            .subscribe((states: DocumentCollection<State>) => {
                states.data.forEach((element: any) => {
                    this.statesTransaction.push(element.attributes.state);
                });
                this.setStateInArray(this.statesTransaction, this.permanentState);
                this.updateStateInArray();
                // let paymentMethodContainer = document.getElementsByClassName('app-payment-method-container') as HTMLCollectionOf<HTMLElement>
                // let paymentMethod = document.getElementsByClassName('app-payment-method') as HTMLCollectionOf<HTMLElement>

                this.testSubject.next(true);
                this.changeDetectorRef.markForCheck();
            });
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
        this.subscriptionState.unsubscribe();
    }
}
